var exports = {
  "Y2": "FriendListItem.module__friendListItem___LW1Obm",
  "lY": "FriendListItem.module__contextMenuActive___LW1Obm",
  "Hb": "FriendListItem.module__friendInfo___LW1Obm",
  "HX": "FriendListItem.module__friendDetails___LW1Obm",
  "Um": "FriendListItem.module__friendNameRow___LW1Obm",
  "G3": "FriendListItem.module__friendName___LW1Obm",
  "tf": "FriendListItem.module__friendTag___LW1Obm",
  "kC": "FriendListItem.module__friendSubtext___LW1Obm",
  "MI": "FriendListItem.module__friendStatusOffline___LW1Obm",
  "wh": "FriendListItem.module__friendStatusOnline___LW1Obm",
  "yA": "FriendListItem.module__friendActions___LW1Obm",
  "I0": "FriendListItem.module__actionButtonMessage___LW1Obm",
  "cQ": "FriendListItem.module__actionButtonMore___LW1Obm",
  "nl": "FriendListItem.module__contextMenuButtonActive___LW1Obm",
  "TI": "FriendListItem.module__actionButtonAccept___LW1Obm",
  "Tl": "FriendListItem.module__actionButtonIgnore___LW1Obm",
  "P7": "FriendListItem.module__actionButtonCancel___LW1Obm",
  "RK": "FriendListItem.module__iconSize___LW1Obm",
};

module.exports = exports;
